import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import { LoggingService } from '@com-delta-idp/mnx-utils';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ContentAccessibilityPopup } from '../../model/content/contentAccessibilityPopup.model';
import { ContentFooter } from '../../model/content/contentfooter.model';
import { ContentSocialIcon } from '../../model/content/contentfootersocial.model';
import { CommonService } from '../../services/common.service';
import { ContentHeaderFooterService } from '../../services/content/contentheaderfooter.service';
import { FlyoutExternalSiteService } from '../../services/flyout-externalsite-service/flyout-externalsite.service';

@Component({
  selector: 'ngc-social-icons',
  templateUrl: './social-icons.component.html'
})
export class SocialIconsComponent implements OnInit, OnDestroy {
  @Input()
  avoidFocus: boolean;

  bsModalRef: BsModalRef;
  config = {
    animated: false
  };

  modalServiceOnHiddenSubscribe: Subscription;
  public contentSocialIcons: ContentSocialIcon[];
  axPopupContent: ContentAccessibilityPopup;
  contentFooter: ContentFooter;
  contentServiceHeaderFooterSubscribe: Subscription;
  private unsubscribe: Subject<void> = new Subject();

  constructor(
    private modalService: BsModalService,
    private changeDetection: ChangeDetectorRef,
    private srv: CommonService,
    private contentService: ContentHeaderFooterService,
    public el: ElementRef,
    private renderer: Renderer2,
    private dragModal: CommonService,
    private FlyoutExternalSiteService: FlyoutExternalSiteService,
    private loggingService: LoggingService
  ) {}

  ngOnInit() {
    this.contentService._isHeaderFooter
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((headerFooterFlag) => {
        if (headerFooterFlag) {
          if (this.contentService.contentHeaderFooter) {
            this.contentServiceHeaderFooterSubscribe =
              this.contentService.contentHeaderFooter
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(
                  (data) => {
                    if (data) {
                      this.contentSocialIcons = data.footer.social.iconValue;
                      this.axPopupContent = data.accessibilityPopup;
                      this.srv.setAxPopupContent(this.axPopupContent);
                      this.contentFooter = data.footer;
                      this.changeDetection.detectChanges();
                    }
                  },
                  (err) => {
                    this.loggingService.log('Caught Error: ' + err);
                  }
                );
          }
        }
      });
  }

  open(item, modalPopupFlag: string) {
    if (modalPopupFlag === 'false') {
      window.open(item.iconLink, '_blank');
    } else {
      this.FlyoutExternalSiteService.openFlyoutExtSiteModal(
        item.iconLink,
        this.el,
        this.renderer
      );
    }
  }

  ngOnDestroy() {
    if (this.contentServiceHeaderFooterSubscribe) {
      this.contentServiceHeaderFooterSubscribe.unsubscribe();
    }
    if (this.modalServiceOnHiddenSubscribe) {
      this.modalServiceOnHiddenSubscribe.unsubscribe();
    }
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.unsubscribe.unsubscribe();
    this.changeDetection.detach();
  }
}
